import { render, staticRenderFns } from "./IconSession.vue?vue&type=template&id=6ddf1a35&"
import script from "./IconSession.vue?vue&type=script&lang=js&"
export * from "./IconSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports